import decodeJwt from 'jwt-decode';
import { DEFAULT_API_CONFIG } from './apiConfig';

const { url } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/verify`;


const getMfaToken = () => sessionStorage.getItem('mfaTempToken');

const getMfaHeaders = () => {
  const token = getMfaToken();
  let defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': '69420',
  };
  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const headers = Object.assign({}, defaultHeaders);
  return headers;
};

// export const verifyLogin = async (username, password) => {
// /////
// };

export const sendMfaCode = async (channel, identifier) => {
  const headers = getMfaHeaders();
  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify({ channel, identifier }),
  };
  const response = await fetch(`${baseRoute}/send-code`, requestOptions);

  if (response.status === 401) {
      throw new Error("Unauthorized");  
   }

  if (response.status < 200 || response.status >= 300) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to send verification code');
  }

  return await response.json();
};

export const verifyMfaCode = async (value, code, channel, canTrustDevice = false, platform = 'browser') => {
  const headers = getMfaHeaders();
  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify({ 
      Value: value, 
      Code: code, 
      Channel: channel,
      CanTrustDevice: canTrustDevice,
      Platform: platform
    }),
  };
  const response = await fetch(`${baseRoute}/verify-code`, requestOptions);
  

  if (response.status < 200 || response.status >= 300) {
    const error = await response.json();
    throw new Error(error.message || 'Invalid verification code');
  }

  const data = await response.json();
  var { authenticatedInspector, deviceId, deviceToken, token } = data;
   if (!token && authenticatedInspector?.token) {
     token = authenticatedInspector.token;
   }
  
  const decodedToken = decodeJwt(token);
  let roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  localStorage.setItem('token', token);
  localStorage.setItem('roles', roles);
  
  // Store trusted device info if returned
  if (deviceId && deviceToken) {
    localStorage.setItem('deviceId', deviceId);
    localStorage.setItem('deviceToken', deviceToken);
  }
  
  return roles;
};

export const getMfaChallengeData = async () => {
  const headers = getMfaHeaders();
  const requestOptions = {
    method: 'GET',
    headers,
  }
  const response = await fetch(`${baseRoute}/mfa-challenge`, requestOptions);

  if (response.status === 401) {
      throw new Error("Unauthorized");  
   }

   if (response.status === 403) {
      throw new Error("Forbidden");  
   }

   if (response.ok) {
    return response.json();
   }

  throw new Error("Error");
}

// export const verifyToken = async jwt => {
//   const url = `${baseRoute}/verifytoken`;
//   const headers = getHeaders();

//   const response = await fetch(url, {
//     method: 'POST',
//     headers,
//   });

//   if (response.ok) {
//     const json = await response.json();
//     const { token, name } = json;
//     const decodedToken = decodeJwt(token);
//     let roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
//     localStorage.setItem('token', token);
//     localStorage.setItem('roles', roles);
//     return json;
//   }

//   throw new Error('Token Unverified');
// };
